import { get } from "react-hook-form";
import { useAssetDetailsContext } from "../../../../context/assetDetailsContext";
import {
	getAssetPartAssemblies,
	getAssetParts,
} from "../../../../repositories/AssetDetailsRepositorie";

type Props = {
	setIsAssetPartsLoading: (isLoading: boolean) => void;
	setAssetPartsError: (err: string) => void;
};

export const useSearchAssetParts = ({
	setIsAssetPartsLoading,
	setAssetPartsError,
}: Props) => {
	const {
		state: { assetSearchId },
		actions: { setListAssetParts },
	} = useAssetDetailsContext();

	return async (includeDescendants = false) => {
		setIsAssetPartsLoading(true);
		setListAssetParts([]);
		const [res, asmRes] = await Promise.all([
			getAssetParts(assetSearchId, includeDescendants),
			getAssetPartAssemblies(assetSearchId, includeDescendants),
		]);
		if (res.ok) {
			const rowsSource = get(res, "data.tables[0].rows", []);
			// Group assemblies by part code so each part row can carry the assemblies that contain
			// it (drives the in-row assembly indicator). Non-fatal if the map call fails.
			const asmRows = asmRes.ok ? get(asmRes, "data.tables[0].rows", []) : [];
			const byPart = new Map<string, any[]>();
			for (const a of asmRows) {
				const key = String(a.PartName);
				if (!byPart.has(key)) byPart.set(key, []);
				byPart.get(key)!.push(a);
			}
			const enriched = rowsSource.map((r: any) => ({
				...r,
				Assemblies: byPart.get(String(r.Name)) ?? [],
			}));
			setListAssetParts(enriched);
			setIsAssetPartsLoading(false);
		} else {
			setAssetPartsError(res.message);
			setIsAssetPartsLoading(false);
		}
	};
};
